import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, tap, throwError, timer } from 'rxjs';
import { CRITICAL_ERROR } from './errors/critical-error.token';
import { AuthService } from '../../services/authentication/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {

  const router = inject(Router);
  const isCritical = req.context.get(CRITICAL_ERROR);
  const authService = inject(AuthService)

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {

      if (error.status === 500 && isCritical) {        

        return timer(3000).pipe(
          tap(() => router.navigate(['/error/internal'])),
          switchMap(() => throwError(() => error))
        )
      }
      return throwError(() => error);
    })
  );
};

